<div class="menu">
	<div class="icon" (click)="toggleMenu(true)">{{ expand ? 'close' : 'menu' }}</div>
</div>
<div class="items" [ngClass]="{ expand: expand }">
	<!-- Expand/Collapse Toggle -->
	<div class="nav-toggle">
		<div class="icon" (click)="toggleMenu()">{{ expand ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right' }}</div>
	</div>

	<!-- Home Icon -->
	<div class="item" [ngClass]="{ expand: expand, active: isHomeActive }" (click)="navigateToHome()" (mousemove)="onNavItemMouseMove($event)">
		<div class="icon icon-image" title="Home Dashboard" [ngClass]="{ active: isHomeActive }">
			<img src="assets/home1.png" alt="Home Dashboard" class="nav-icon-img home-icon-img" width="32" height="32">
		</div>
		<div class="title" [ngClass]="{ expand: expand, active: isHomeActive }">Home</div>
	</div>

	   <!-- Upload Icon -->
	   <div class="item" *ngIf="(selectedBU$ | async) as selectedBU; else noUpload" 
	   		[hidden]="selectedBU !== 'RBU'"
			[ngClass]="{ 
				expand: expand, 
				disabled: !isBuSelected || router.url === '/upload', 
				active: isBuSelected && (uploadModal$ | async) && router.url !== '/upload'
			}" 
			(click)="openUploadModal()"
			(mousemove)="onNavItemMouseMove($event)">
		   <div class="icon icon-image" title="Upload Excel" 
				[ngClass]="{ active: isBuSelected && (uploadModal$ | async) && router.url !== '/upload' }">
			   <img src="assets/upload.png" alt="Upload Excel" class="nav-icon-img upload-icon-img" width="32" height="32">
		   </div>
		   <div class="title" 
				[ngClass]="{ expand: expand, active: isBuSelected && (uploadModal$ | async) && router.url !== '/upload' }">
			   Upload
		   </div>
	   </div>
	   <ng-template #noUpload></ng-template>

	   <ng-container *ngFor="let item of navItems">
		   <div class="item"
				[ngClass]="{ 
					active: isNavItemActive(item),
					expand: expand, 
					disabled: !isBuSelected
				}"
				(click)="navigateTo(item)"
				(mousemove)="onNavItemMouseMove($event)">
			   <div class="icon" [title]="item.title"
					[ngClass]="{ 
						active: isNavItemActive(item),
						'icon-image': item.imageIcon
					}">
					<img *ngIf="item.imageIcon" [src]="item.imageIcon" [alt]="item.title" [ngClass]="{ 'nav-icon-img': true, 'oil-rig-icon-img': item.imageIcon.includes('oil-rig') }" width="32" height="32">
					<span *ngIf="!item.imageIcon">{{ item.icon }}</span>
			   </div>
			   <div class="title" [ngClass]="{ 
					active: isNavItemActive(item),
					expand: expand 
				}">{{ item.title }}</div>

			   <ng-container *ngFor="let subItem of navSubItems">
				   <div class="sub" [ngClass]="{ expand: expand }" *ngIf="subItem.parent === item.title">
					   <div class="arrow" [ngClass]="{ active: isSubItemActive(subItem) }">►</div>
					   <div class="line"></div>
					   <div class="icon" [ngClass]="{ active: isSubItemActive(subItem) }" [title]="subItem.title" (click)="navigateTo(subItem)">{{ subItem.icon }}</div>
					   <div class="title" [ngClass]="{ active: isSubItemActive(subItem) }" (click)="navigateTo(subItem)">{{ subItem.title }}</div>
				   </div>
			   </ng-container>
		   </div>
	   </ng-container>

	<div class="toggle" [ngClass]="{ expand: expand }">
		<div [title]="appTitle" class="icon" (click)="toggleFullscreen()">{{ appIcon }}</div>
	</div>
</div>

<footer [ngClass]="{ expand: expand }"></footer>
